'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/social/Chat.tsx
import { jsx } from "react/jsx-runtime";
var ChatIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4C7.58172 4 4 7.58172 4 12C4 13.2058 4.26609 14.3466 4.7418 15.3694C4.92997 15.774 4.99885 16.2522 4.88275 16.728L4.1041 19.919L7.43287 19.1674C7.88799 19.0646 8.34252 19.1299 8.73063 19.3039C9.7275 19.7509 10.8333 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.5458 22 9.16153 21.689 7.91234 21.1288C7.88806 21.1179 7.87434 21.1184 7.87217 21.1185L4.54464 21.8699C3.09629 22.197 1.80913 20.8874 2.16111 19.4449L2.93944 16.2552C2.93961 16.2529 2.94023 16.2384 2.92835 16.2129C2.33228 14.9313 2 13.5031 2 12Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Facebook.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Facebook = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          d: "M9.58404 21.706V15.0561H7.52015V12H9.58404V10.6833C9.58404 7.27944 11.124 5.70333 14.464 5.70333C15.0963 5.70333 16.1879 5.82722 16.6363 5.95111V8.71944C16.4001 8.69556 15.9879 8.68333 15.4801 8.68333C13.8401 8.68333 13.2079 9.30333 13.2079 10.9194V12H16.4763L15.9163 15.0556H13.2124V21.9277C18.1637 21.3279 22 17.112 22 12C22 6.47722 17.5228 2 12 2C6.47722 2 2 6.47722 2 12C2 16.6899 5.22813 20.6253 9.58404 21.706Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/LinkedIn.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var LinkedIn = (props) => {
  return /* @__PURE__ */ jsx3(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx3(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.625 21.8037C18.5547 21.8037 19.3496 21.4736 20.0098 20.8135C20.6699 20.1533 21 19.3584 21 18.4287V7.17871C21 6.24902 20.6699 5.4541 20.0098 4.79395C19.3496 4.13379 18.5547 3.80371 17.625 3.80371H6.375C5.44531 3.80371 4.65039 4.13379 3.99023 4.79395C3.33008 5.4541 3 6.24902 3 7.17871V18.4287C3 19.3584 3.33008 20.1533 3.99023 20.8135C4.65039 21.4736 5.44531 21.8037 6.375 21.8037H17.625ZM7.12424 9.63968H7.11253C6.66721 9.63968 6.30588 9.50491 6.02854 9.23538C5.7512 8.96585 5.61253 8.63186 5.61253 8.23342C5.61253 7.82717 5.7551 7.49124 6.04026 7.22561C6.32542 6.95999 6.69456 6.82717 7.14768 6.82717C7.60081 6.82717 7.96409 6.95999 8.23753 7.22561C8.51096 7.49124 8.65159 7.82717 8.6594 8.23342C8.6594 8.63186 8.51878 8.96585 8.23753 9.23538C7.95628 9.50491 7.58518 9.63968 7.12424 9.63968ZM8.48414 18.8741H5.77711V10.7412H8.48414V18.8741ZM12.6792 11.8911L12.7739 11.7481C13.3368 10.9519 14.1141 10.5537 15.1058 10.5537C16.0433 10.5537 16.7972 10.8623 17.3675 11.4795C17.9378 12.0967 18.223 13.0069 18.223 14.21V18.8741H15.5159V14.5264C15.5159 13.2998 15.0628 12.6866 14.1565 12.6866C13.8128 12.6866 13.5237 12.7823 13.2894 12.9737C13.055 13.1651 12.8792 13.3975 12.762 13.6709C12.7073 13.8116 12.68 14.0303 12.68 14.3272V18.8741H9.97295C9.983 16.7714 9.98874 15.0719 9.99017 13.7757V12.6139C9.98874 11.5864 9.983 10.9622 9.97295 10.7412H12.68L12.6792 11.8911Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Mail.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var Mail = (props) => {
  return /* @__PURE__ */ jsx4(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx4(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M1.66699 3.33334H18.3337V16.6667H1.66699V3.33334ZM3.33366 5.00001V6.56832L10.0003 9.90165L16.667 6.56831V5.00001H3.33366ZM16.667 8.4317L10.0003 11.765L3.33366 8.43171V15H16.667V8.4317Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Messenger.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var Messenger = (props) => {
  return /* @__PURE__ */ jsx5(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx5(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 9C2 5.68629 4.68629 3 8 3H16C19.3137 3 22 5.68629 22 9V15C22 18.3137 19.3137 21 16 21H3C2.44772 21 2 20.5523 2 20V9ZM8 5C5.79086 5 4 6.79086 4 9V19H16C18.2091 19 20 17.2091 20 15V9C20 6.79086 18.2091 5 16 5H8ZM8 10C8 9.44772 8.44772 9 9 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H9C8.44772 11 8 10.5523 8 10ZM8 14C8 13.4477 8.44772 13 9 13H12C12.5523 13 13 13.4477 13 14C13 14.5523 12.5523 15 12 15H9C8.44772 15 8 14.5523 8 14Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/social/Whatsapp.tsx
import { jsx as jsx6, jsxs } from "react/jsx-runtime";
var Whatsapp = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    __spreadProps(__spreadValues({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: [
        /* @__PURE__ */ jsx6(
          "path",
          {
            d: "M7.60567 6.21294C7.74897 6.21874 7.90771 6.22553 8.05857 6.56063C8.16132 6.78928 8.33407 7.21502 8.47205 7.55507C8.57428 7.80702 8.65742 8.01193 8.67885 8.05475C8.72921 8.15535 8.7626 8.27315 8.6956 8.40725C8.6853 8.42787 8.6758 8.4473 8.66673 8.46585C8.61681 8.56797 8.57993 8.64338 8.49461 8.74279C8.46051 8.78251 8.42527 8.82536 8.39006 8.86817C8.32114 8.95196 8.25234 9.0356 8.19256 9.0953C8.09163 9.19558 7.98653 9.30462 8.10411 9.50594C8.22168 9.70727 8.62554 10.3661 9.22382 10.8996C9.86776 11.4737 10.4269 11.7162 10.71 11.8389C10.765 11.8627 10.8095 11.882 10.8423 11.8984C11.0437 11.999 11.161 11.9822 11.2784 11.8478C11.3959 11.7135 11.7811 11.2604 11.9155 11.059C12.0498 10.8575 12.1839 10.8909 12.3684 10.9581C12.5528 11.0253 13.5422 11.5122 13.7436 11.6129C13.7832 11.6327 13.8202 11.6506 13.8545 11.6671C13.9946 11.7346 14.0891 11.7802 14.1295 11.8478C14.1797 11.932 14.1796 12.3347 14.012 12.8046C13.8444 13.2746 13.0228 13.7279 12.6537 13.7614C12.6181 13.7647 12.5828 13.7688 12.5465 13.7731C12.2054 13.8132 11.7749 13.8637 10.2385 13.2579C8.34617 12.5116 7.09894 10.6616 6.843 10.2819C6.82225 10.2511 6.80802 10.23 6.80048 10.2199L6.7981 10.2167C6.68911 10.071 5.97877 9.1212 5.97877 8.13849C5.97877 7.21211 6.434 6.7263 6.64364 6.50258C6.65808 6.48717 6.67135 6.47301 6.68323 6.46003C6.86759 6.25859 7.08566 6.20823 7.21988 6.20823L7.60567 6.21294Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx6(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.94922 18.125L3.09203 13.9525C2.38601 12.7284 2.01517 11.3399 2.01687 9.92687C2.01874 5.48701 5.63184 1.875 10.0718 1.875C12.2264 1.87609 14.2487 2.71456 15.7696 4.23659C17.2906 5.75862 18.1274 7.78171 18.1266 9.93333C18.1247 14.3729 14.511 17.9855 10.0717 17.9855H10.0682C8.72023 17.985 7.3957 17.6468 6.21917 17.0053L1.94922 18.125ZM10.0742 3.23522C6.3813 3.23522 3.37808 6.23735 3.37677 9.92741C3.37495 11.1875 3.72978 12.4223 4.40025 13.4892L4.55953 13.7424L3.88309 16.2119L6.41699 15.5475L6.66167 15.6925C7.68931 16.3024 8.86759 16.6249 10.0692 16.6255H10.0717C13.7618 16.6255 16.765 13.6231 16.7664 9.93278C16.7692 9.05321 16.5975 8.18183 16.2612 7.36908C15.9249 6.55633 15.4308 5.81836 14.8074 5.19789C14.1874 4.57402 13.4498 4.07932 12.6374 3.74243C11.8249 3.40554 10.9537 3.23314 10.0742 3.23522Z",
            fill: "currentColor"
          }
        )
      ]
    })
  );
};

// src/social/X.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var X = (props) => {
  return /* @__PURE__ */ jsx7(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "25",
      viewBox: "0 0 24 25",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx7(
        "path",
        {
          d: "M4.08849 5.36328L10.2273 13.5712L4.0498 20.2447H5.44022L10.8487 14.4018L15.2185 20.2447H19.9498L13.4655 11.5751L19.2155 5.36328H17.8251L12.8443 10.7443L8.81981 5.36328H4.08849ZM6.13316 6.38734H8.3067L17.9049 19.2206H15.7313L6.13316 6.38734Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  ChatIcon,
  Facebook,
  LinkedIn,
  Mail,
  Messenger,
  Whatsapp,
  X
};
//# sourceMappingURL=chunk-2MAFZYDD.mjs.map